import * as React from "react";
import cx from "classnames";
import {
  useComponentDidMountByLayoutEffect,
  useEventListener,
} from "@vingle/wtf-sdk/helpers/hook";
import { isBrowser } from "@vingle/wtf-sdk/helpers/envChecker";
import hexToRgba from "@vingle/wtf-sdk/helpers/hexToRgba";

const styles = require("./trendingSectionBackground.scss");

interface IProps {
  section: Vingle.Discover.ITrendingSection;
  cover?: "height" | "width";
  className?: Parameters<typeof cx>[0];
}

function TrendingSectionBackground({
  section,
  className,
  cover = "width",
  ...rests
}: IProps) {
  const ref = React.useRef<HTMLImageElement>(null);
  const [style, setStyle] = React.useState<React.CSSProperties>({
    [cover]: "100%",
  });
  const imageLoadedStyle = React.useCallback(() => {
    if (ref.current) {
      const imageEl = ref.current;
      setStyle(prevStyle => ({
        ...prevStyle,
        marginLeft: `${-imageEl.offsetWidth / 2}px`,
        marginTop: `${-imageEl.offsetHeight / 2}px`,
      }));
    }
  }, []);

  if (isBrowser()) {
    useEventListener("resize", imageLoadedStyle);
    useComponentDidMountByLayoutEffect(() => {
      if (ref.current) {
        if (ref.current.complete && ref.current.naturalWidth) {
          imageLoadedStyle();
        } else {
          ref.current.addEventListener("load", imageLoadedStyle);
        }
      }
    });
  }

  return section.display.background &&
    section.display.background.type === "image" ? (
    <img
      src={section.display.background.value}
      alt=""
      style={style}
      ref={ref}
      className={cx(styles.backgroundImage, className)}
      {...rests}
    />
  ) : (
    <div
      className={cx(styles.backgroundColor, className)}
      style={{
        ...style,
        backgroundColor: section.display.background
          ? hexToRgba(section.display.background.value)
          : undefined,
      }}
      {...rests}
    />
  );
}

export default React.memo(TrendingSectionBackground);
